/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_PhoneInputs */

const en_cp_form_phone = /** @type {(inputs: Cp_Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp (optional)`)
};

const id_cp_form_phone = /** @type {(inputs: Cp_Form_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp (opsional)`)
};

/**
* | output |
* | --- |
* | "WhatsApp (optional)" |
*
* @param {Cp_Form_PhoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_phone = /** @type {((inputs?: Cp_Form_PhoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_PhoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_phone(inputs)
	return en_cp_form_phone(inputs)
});